import { ReactNode, useCallback, useEffect, useState } from "react";
import Page from "../../layout/Page";
import Herobox from "../Herobox";
import "./style.scss";
import { useUiMessageContext } from "./context";
import { ERROR, SUCCESS, WARN } from ".";
import BjelinButton from "../BjelinButton";
import { RouteChildrenProps } from "react-router";

const UIMessagesTestPage = (_props: RouteChildrenProps): ReactNode => {
  const { displayMessage, displayConfirmDialog } = useUiMessageContext();
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      displayMessage({
        text: "Button test",
        type: "info",
        persist: true,
        code: "buttons",
        buttons: [
          {
            text: "Button 1",
            type: "primary",
            onClick: () => {
              displayMessage({
                text: "Button 1 clicked",
                type: "info"
              });
            }
          },
          {
            text: "Button 2",
            type: "secondary",
            onClick: () => {
              displayMessage({
                text: "Button 2 clicked",
                type: "info"
              });
            }
          }
        ]
      });
    }, 100);
    setTimeout(() => {
      displayMessage({
        text: "Error",
        type: ERROR,
        code: "error"
      });
    }, 200);
    setTimeout(() => {
      displayMessage({ text: "Info", type: "info" });
    }, 300);
    setTimeout(() => {
      displayMessage({
        text: "Warn - long message - long message - long message - long message - long message",
        type: WARN
      });
    }, 400);
    setTimeout(() => {
      displayMessage({
        text: "Success",
        type: SUCCESS
      });
    }, 400);

    setTimeout(() => {
      displayMessage({ text: "Info banner", banner: true });
    }, 400);
    setTimeout(() => {
      displayMessage({
        text: "Warn - long message - long message - long message - long message - long message",
        type: WARN,
        banner: true
      });
    }, 200);
    setTimeout(() => {
      displayMessage({
        text: "Error banner",
        type: ERROR,
        banner: true
      });
    }, 300);
    setTimeout(() => {
      displayMessage({
        text: "Success banner",
        type: SUCCESS,
        banner: true
      });
    }, 400);
    setTimeout(() => {
      displayMessage({
        text: "Buttons banner",
        type: "info",
        banner: true,
        buttons: [
          {
            text: "Button 1",
            type: "primary",
            onClick: () => {
              displayMessage({
                text: "Banner button 1 clicked",
                type: "info"
              });
            }
          },
          {
            text: "Button 2",
            type: "secondary",
            onClick: () => {
              displayMessage({
                text: "Banner button 2 clicked",
                type: "info"
              });
            }
          }
        ]
      });
    }, 400);
  }, [displayMessage]);

  const testConfirmDialog = useCallback(() => {
    displayConfirmDialog("Are you sure?")
      .then(() => {
        setConfirmed(true);
      })
      .catch(_error => {
        setConfirmed(false);
      });
  }, [displayConfirmDialog]);

  return (
    <Page
      name="ui-messages-test-page"
      key="ui-messages-test-page"
      title="ui-messages-test-page"
      noindex={true}
    >
      <Herobox type="slim" textShadow={true} className={"text-center"}>
        <h1>iu-messages-test-page</h1>
      </Herobox>
      <BjelinButton
        color="black"
        className="confirm-button"
        onClick={testConfirmDialog}
      >
        Show confirm dialog
      </BjelinButton>
      {confirmed && <div className="confirmed-message">Confirmed!</div>}
    </Page>
  );
};

export default UIMessagesTestPage;
